// 预览页获取中奖数据并轮播
function initMarquee (hdIndex, num, lineHeight) {
  window.console.log('initMarquee', hdIndex, num, lineHeight);

  var curIndex = 0;
  var list = [];
  var recordTimer = null;
  function handleScroll () {
    var newIndex = 0
    if (curIndex < list.length - 1) {
      newIndex = curIndex + 1
    }
    window.console.log(newIndex)
    curIndex = newIndex
    const recordsBox = document.querySelector('#recordsBox')
    if (recordsBox) {
      if (newIndex) {
        recordsBox.scroll({
          top: newIndex * parseInt(lineHeight),
          left: 0,
          behavior: "smooth"
        })
      } else {
        recordsBox.scrollTo(0, 0)
      }
    }
  }

  function getTime (timestamp) {
    const d = new Date(timestamp)
    return d.toLocaleString()
  }

  function handleList (res) {
    window.console.log('handleList', res);
    try {
      list = res.data || [];
      var str = '';
      for(var i = 0; i < list.length; i++) {
        var item = list[i];
        str += '<div>恭喜Y号<strong class="pfa-marquee--yyno">' + item.yyNo + '</strong>在' + getTime(item.luckTime) + '抽中了<strong class="pfa-marquee--award">' + item.pidName + '</strong></div>';
      }
      document.querySelector('#recordsBox').innerHTML = str;
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) {
          window.console.log("hidden");
          window.clearInterval(recordTimer);
          recordTimer = null;
        } else {
          window.console.log("show");
          window.clearInterval(recordTimer);
          recordTimer = null;
          recordTimer = setInterval(handleScroll, 2000);
        }
      })
      // 开始轮播
      recordTimer = setInterval(handleScroll, 2000);
    } catch (e) {}
  }

  if (hdIndex) {
    var url = window.location.protocol + '//' + window.location.host + '/service/hdplatform/gift/' + hdIndex + '/luckList?num=' + num;
    $.ajax({
      url: url,
      dataType: "jsonp",
      success: function (res) {
        handleList(res);
      }
    })
  }
}

module.exports = {
  init: initMarquee
}


//////////////////
// WEBPACK FOOTER
// /data/services/vipm-hdplfm/server/pagefactory/components/avalon/Marquee/record.js
// module id = 25
// module chunks = 0